import { IpadConfigCreation } from '@/features/ipad-configs/components';

const IpadConfigurationCreationPage = () => {
  return <IpadConfigCreation />;
};

export default IpadConfigurationCreationPage;
